export default "__VITE_ASSET__f9f77a91__"